import { useCallback, useState } from "react";

export const useDialog = (isInitialOpen?: boolean) => {
  const [isOpen, setIsOpen] = useState(!!isInitialOpen);

  const close = useCallback(() => setIsOpen(false), []);

  const open = useCallback(() => setIsOpen(true), []);

  return { close, isOpen, open };
};
